module.exports = __webpack_public_path__ + "img/status-completed.99689373.svg";